<template>
  <div class="field" :class="colSize">
    <label class="block" :class="labelClass" :style="labelStyle">{{ __(label) }}</label>
    <ColorPicker style="width:100%" :name="fieldName" :inline="inline" :format="format" :defaultColor="defaultColor"
      class="w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black-500/50"
      :disabled="isFormDisabled" v-focus="isFocus" :unstyled="false" v-model="field" />
  </div>
</template>

<script setup>
import ColorPicker from 'primevue/colorpicker';
import { __ } from '@pages/Helper/utils.js'

const props = defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: null,
  },
  size: {
    type: String,
    default: null
  },
  isFocus: {
    type: Boolean,
    default: false
  },
  isFormDisabled: {
    type: Boolean,
    default: false
  },
  inline: {
    type: Boolean,
    default: false
  },
  format: {
    type: String,
    default: 'hex'
  },
  labelClass: {
    type: String,
    default: null
  },
  labelStyle: {
    type: [Object, String],
    default: null
  },
  defaultColor: {
    type: String,
    default: '#ffffff'
  },
});

const field = defineModel('field');
const colSize = props?.size ? 'col-' + props.size : 'col';

</script>

<style lang="scss" scoped></style>
